module.exports = __webpack_public_path__ + "img/pleasure-icon-8.38d785b9.svg";